import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-gray-900">
            Politika privatnosti
          </DialogTitle>
          <DialogDescription>
            TDM DRAGON promet d.o.o. - Politika zaštite privatnosti
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-6 text-gray-700">
            <p className="leading-relaxed">
              Ovom Politikom privatnosti objašnjavamo kako TDM DRAGON prikuplja, koristi, obrađuje i štiti vaše osobne podatke prilikom korištenja web stranice www.tdm-dragon.eu
            </p>

            <p className="leading-relaxed">
              Zaštita vaše privatnosti i osobnih podataka izuzetno nam je važna te se obvezujemo postupati u skladu s važećim propisima o zaštiti osobnih podataka.
            </p>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                1. Voditelj obrade osobnih podataka
              </h3>
              <p className="leading-relaxed">
                Voditelj obrade osobnih podataka je:
              </p>
              <p className="leading-relaxed font-medium">
                TDM DRAGON<br />
                Web stranica: www.tdm-dragon.eu
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                2. Osobni podaci koje prikupljamo
              </h3>
              <p className="leading-relaxed">
                Ovisno o načinu na koji koristite našu web stranicu, možemo prikupljati sljedeće kategorije osobnih podataka:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>ime i prezime</li>
                <li>e-mail adresu</li>
                <li>broj telefona</li>
                <li>sadržaj upita i poruka koje nam šaljete</li>
                <li>podatke koje dobrovoljno dostavite putem kontakt obrasca ili e-maila</li>
                <li>tehničke podatke (IP adresa, vrsta uređaja, operativni sustav, vrsta preglednika, podaci o kolačićima)</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                3. Način prikupljanja podataka
              </h3>
              <p className="leading-relaxed">Osobne podatke prikupljamo:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>kada nas kontaktirate putem web stranice</li>
                <li>kada nam pošaljete e-mail ili drugi upit</li>
                <li>automatski prilikom korištenja web stranice (kroz kolačiće i slične tehnologije)</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                4. Svrhe obrade osobnih podataka
              </h3>
              <p className="leading-relaxed">Vaše osobne podatke obrađujemo u sljedeće svrhe:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>odgovaranje na vaše upite i komunikaciju</li>
                <li>pružanje informacija o našim uslugama i ponudi</li>
                <li>unaprjeđenje korisničkog iskustva i funkcionalnosti web stranice</li>
                <li>analizu korištenja web stranice</li>
                <li>ispunjavanje zakonskih i regulatornih obveza</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                5. Pravna osnova obrade
              </h3>
              <p className="leading-relaxed">Obrada osobnih podataka temelji se na:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>vašoj privoli</li>
                <li>poduzimanju radnji na vaš zahtjev prije sklapanja ugovora</li>
                <li>izvršenju ugovora</li>
                <li>legitimnom interesu voditelja obrade</li>
                <li>zakonskim obvezama</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                6. Čuvanje i zaštita osobnih podataka
              </h3>
              <p className="leading-relaxed">
                Osobne podatke čuvamo samo onoliko dugo koliko je potrebno za ostvarenje svrhe obrade, osim ako važeći propisi ne zahtijevaju dulje razdoblje čuvanja.
              </p>
              <p className="leading-relaxed">
                Primjenjujemo odgovarajuće tehničke i organizacijske mjere zaštite kako bismo spriječili neovlašteni pristup, gubitak, zlouporabu ili otkrivanje osobnih podataka.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                7. Dostupnost i prijenos podataka trećim stranama
              </h3>
              <p className="leading-relaxed">
                Vaši osobni podaci neće se prodavati, iznajmljivati niti neovlašteno dijeliti trećim stranama.
              </p>
              <p className="leading-relaxed">
                Podaci se mogu proslijediti pouzdanim partnerima isključivo kada je to nužno radi:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>pružanja određenih usluga</li>
                <li>ispunjavanja zakonskih obveza</li>
              </ul>
              <p className="leading-relaxed">
                U takvim slučajevima osiguravamo da se podaci obrađuju u skladu s važećim propisima.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                8. Prava ispitanika
              </h3>
              <p className="leading-relaxed">U skladu s važećim propisima imate pravo:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>na pristup osobnim podacima</li>
                <li>na ispravak netočnih ili nepotpunih podataka</li>
                <li>na brisanje osobnih podataka („pravo na zaborav")</li>
                <li>na ograničenje obrade</li>
                <li>na prigovor na obradu podataka</li>
                <li>na prenosivost podataka</li>
                <li>na povlačenje privole u bilo kojem trenutku</li>
              </ul>
              <p className="leading-relaxed">
                Također imate pravo podnijeti pritužbu nadležnom nadzornom tijelu.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                9. Kontakt za pitanja vezana uz privatnost
              </h3>
              <p className="leading-relaxed">
                Za sva pitanja, zahtjeve ili prigovore vezane uz obradu osobnih podataka možete nas kontaktirati putem kontakt podataka navedenih na web stranici.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                10. Izmjene Politike privatnosti
              </h3>
              <p className="leading-relaxed">
                Zadržavamo pravo izmjene ove Politike privatnosti u bilo kojem trenutku. Ažurirana verzija uvijek će biti dostupna na web stranici te stupa na snagu danom objave.
              </p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyPolicyModal;
